import {List, Map, fromJS, OrderedSet} from "immutable";
import {isImmutable} from 'trustar/utils/utils.js';

export const formatTagsToBulk = (tags: any, tagsToRemove: any) => {
  let tagPayloadInit = {
    addedTags: List(),
    removedTags: List()
  };

  const output = {
    addedTags: tags.map(currentTag => ({
      name: currentTag.name,
      enclaveId: currentTag.enclaveGuid || currentTag.enclaveId
    })),
    removedTags: tagsToRemove.map(currentTag => ({
      name: currentTag.name,
      enclaveId: currentTag.enclaveGuid || currentTag.enclaveId
    })),
  };

  return output;
};

export const formatBulkTagResponse = (tagResponseObjectOrMap: Object | Map<any, any>, enclaveTagCombinations) => {
  const tagResponse = isImmutable(tagResponseObjectOrMap) ? tagResponseObjectOrMap : fromJS(tagResponseObjectOrMap);

  const tagsToEnclavesIds = enclaveTagCombinations.reduce((tagMap, current) => tagMap.set(current.name, current.enclaveId), Map());
  const retroFittedTagsWithEnclaveIds = tagResponse
    .update('addedTags', addedTags =>
      addedTags.map(tagMapOrObject => {
        const tag = isImmutable(tagMapOrObject) ? tagMapOrObject : Map(tagMapOrObject);
        return tag.set('enclaveId', tagsToEnclavesIds.get(tag.get('name')))
      }))
    .update('removedTags', removedTags =>
      removedTags.map(tagMapOrObject => {
        const tag = isImmutable(tagMapOrObject) ? tagMapOrObject : Map(tagMapOrObject);
        return tag.set('enclaveId', tagsToEnclavesIds.get(tag.get('name')))
      }));
  return retroFittedTagsWithEnclaveIds;
};

export const bulkTagSuccessMessage = (addedTags = List(), removedTags = List()) => {
  const totalAddedTags = addedTags && addedTags.length ? addedTags.length : 0;
  const totalRemovedTags = removedTags && removedTags.length ? removedTags.length : 0;
  const successMessage = `${totalAddedTags ? totalAddedTags + (totalAddedTags === 1 ? ' tag ' : ' tags ') + 'added' : ''}
        ${totalAddedTags && totalRemovedTags ? ' and ' : ''}
        ${totalRemovedTags ? totalRemovedTags + (totalRemovedTags === 1 ? ' tag ' : ' tags ') + 'removed' : ''}`;

  return successMessage;
};



// WEBPACK FOOTER //
// ./src/app/modules/tags/utils.js